import Login from '@/components/Login';

export default 		{
    path: '/login',
    name: 'Login',
    component: Login
}